/**
 * Application configuration variables
 * 
 * This file centralizes all configuration variables for the application,
 * including feature flags and environment-specific settings.
 * 
 * Usage:
 * - To hide the 'gestione collegamenti' button, set environment variable:
 *   NEXT_PUBLIC_SHOW_LINK_MANAGEMENT=false
 * - To show the button (default behavior), either omit the variable or set:
 *   NEXT_PUBLIC_SHOW_LINK_MANAGEMENT=true
 */

export const config = {
  /**
   * Controls visibility of the 'gestione collegamenti' (manage linkings) button in Dashboard
   * Set to false to hide the button from users
   * @default true
   */
  showLinkManagement: false,
  /**
   * Controls visibility of the project card in Dashboard
   * Set to false to hide the project card from users
   * @default true
   */
  showProjectCardInDashboard: false
} as const

export default config